
// src/web/components/group-nav.jsx

import React from 'react'
import NotificationBadge from 'react-notification-badge';
import {Effect} from 'react-notification-badge';
import connect from '../../connects/group-nav'
import {
  AppBar,
} from 'react-toolbox/lib/app_bar'
import {
  IconButton,
} from 'react-toolbox/lib/button'
import {
  IconMenu,
  MenuItem,
} from 'react-toolbox/lib/menu'
import {
  Navigation
} from 'react-toolbox/lib/navigation'
import Avatar from 'react-toolbox/lib/avatar'
import Tooltip from 'react-toolbox/lib/tooltip'
import GroupSettingsPage from './group-settings-page.jsx'
import SearchDrawer from './search-drawer.jsx'
import zIndexMenuTheme from './themes/z-index-menu.css'
import noWrappedNavigationTheme from './themes/no-wrapped-navigation.css'
import appBarTheme from './themes/app-bar.css'
import animation from './animation-css'

const TooltipIconButton = Tooltip(IconButton)
const TooltipIconMenu = Tooltip(IconMenu)

class GroupNav extends React.Component {
  componentDidMount() {
    document.title = this.props.notificationUnreadCount > 0 ? `(${this.props.notificationUnreadCount}) ${this.props.group.name} - gamba!` : `${this.props.group.name} - gamba!`     
}
  componentDidUpdate(prevProps) {
    if (this.props.group && prevProps.group && this.props.group.group_id != prevProps.group.group_id ||
        this.props.group && !prevProps.group ||
        this.props.notificationUnreadCount != prevProps.notificationUnreadCount)
         document.title = this.props.notificationUnreadCount > 0 ? `(${this.props.notificationUnreadCount}) ${this.props.group.name} - gamba!` : `${this.props.group.name} - gamba!`     
  }
  render() {
    const {
      t,
      ui,
      group,
      user,
      onLeftIconClick,
      isPhone,
      notificationUnreadCount,
      showNotifications,
      showChatRooms,
      chatUnreadCount,
      openGroupSettingsPage,
      openMembersPage,
      openDashboardPage,
      openReportStatusPage,
      openKPIPage,
      openAlbum,
      toggleFavorite,
      updateUI,
      blinkChatButton,
      openSearchDrawer,
      openDrawer,
    } = this.props

    return (
      <AppBar leftIcon={isPhone && 'menu' || ''}
            onLeftIconClick={onLeftIconClick}
            theme={appBarTheme}>
        <div className={appBarTheme.header} style={{ marginRight: 'auto', whiteSpace: 'nowrap', overflow: 'hidden', cursor: group.is_admin ? 'pointer' : undefined }}
            onClick={group.is_admin ? openGroupSettingsPage : undefined} >
          {!isPhone && (
            <div style={{ display: 'inline' }}>
              <Avatar image={group.icon_image.thumb_url}/>
              &nbsp;
            </div>
          )}
          <b>{group.name}</b>
        </div>
        <Navigation type='horizontal' theme={noWrappedNavigationTheme}>
          <NotificationBadge count={notificationUnreadCount}
              containerStyle={{ position: 'absolute', top: '10px', right: '50px'}}
              effect={Effect.SCALE}/>
          <NotificationBadge count={chatUnreadCount}
              containerStyle={{ position: 'absolute', top: '10px', right: '0px'}}
              effect={Effect.SCALE}/>

          <TooltipIconButton inverse={!isPhone}
              tooltip={t('label:検索')}
              icon="search"
              onClick={openSearchDrawer}/>

          <TooltipIconMenu inverse={!isPhone} tooltip={t('label:メニュー')} icon='more_vert' theme={zIndexMenuTheme}>
            <MenuItem icon='people' caption={t('label:メンバー')} onClick={openMembersPage} />
            <MenuItem icon='check_box' caption={t('label:日報提出状況')} onClick={openReportStatusPage} />
            <MenuItem icon='insert_chart' caption={t('label:KPI進捗状況')} onClick={openKPIPage} />
            <MenuItem icon='photo_library' caption={t('label:アルバム')}  onClick={openAlbum}/>
            <MenuItem icon='insights' caption={t('label:インサイト')} onClick={openDashboardPage} />
            {!group.is_member &&
              <MenuItem icon={group.favorite && 'outlined_flag' || 'flag'}
                onClick={toggleFavorite}
                caption={group.favorite && t('label:お気に入りから削除') || t('label:お気に入りに追加')} />
            }
            {group.is_admin &&
              <MenuItem icon='settings' caption={t('label:グループ設定')} onClick={openGroupSettingsPage} />
            }
          </TooltipIconMenu>

          <TooltipIconButton inverse={!isPhone}
              tooltip={t('label:新着の通知')}
              icon={'notifications'+(!notificationUnreadCount && '_none' || '')}
              onClick={showNotifications}>
          </TooltipIconButton>

          <TooltipIconButton inverse={!isPhone}
              {...animation(blinkChatButton)}
              tooltip={t('label:チャット')}
              icon={'comment'}
              onClick={showChatRooms}>
          </TooltipIconButton>

          {group.is_admin && <GroupSettingsPage group={group} user={user} />}
          <SearchDrawer group={group} active={openDrawer} onClose={openSearchDrawer} />
        </Navigation>
      </AppBar>
    )
  }
}

export const RawGroupNav = GroupNav
export default connect(GroupNav)



// WEBPACK FOOTER //
// ./src/web/components/group-nav.jsx